var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1285 9.04859C12.0135 11.7969 9.7499 13.9899 6.97329 13.9899C4.12305 13.9899 1.8125 11.6017 1.8125 8.82914C1.8125 8.45856 1.80586 7.71793 2.36152 6.46836C2.69406 5.72054 2.90264 5.25074 3.02035 4.8213C3.08502 4.58528 3.2108 4.2103 3.56937 4.8213C3.78079 5.18157 3.78897 5.69973 3.78897 5.69973C3.78897 5.69973 4.57561 5.09609 5.10662 3.94287C5.88508 2.25227 5.26397 1.24169 5.05172 0.538948C4.97826 0.295842 4.93214 -0.141068 5.43603 0.0448305C5.94948 0.234297 7.30687 1.18449 8.01642 2.18601C9.02909 3.61538 9.38897 4.98601 9.38897 4.98601C9.38897 4.98601 9.71322 4.58358 9.82819 4.16248C9.95803 3.68697 9.95995 3.21602 10.3772 3.72332C10.7739 4.20574 11.3632 5.11234 11.6949 5.97424C12.2971 7.53944 12.1285 9.04859 12.1285 9.04859Z",
    fill: "url(#paint0_linear_8106_43348)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97292 13.9894C5.002 13.9894 3.4043 12.3917 3.4043 10.4207C3.4043 9.23151 3.88354 8.5095 4.88094 7.53037C5.51956 6.90345 6.11728 6.13345 6.37131 5.60913C6.42132 5.50592 6.53514 4.96804 6.97397 5.59782C7.20417 5.92812 7.56504 6.51551 7.79645 7.01682C8.19537 7.88114 8.29057 8.71878 8.29057 8.71878C8.29057 8.71878 8.68153 8.48841 8.9494 7.89525C9.03576 7.70408 9.21034 6.98037 9.69842 7.70397C10.0565 8.23499 10.5485 9.18973 10.5416 10.4207C10.5416 12.3917 8.9438 13.9894 6.97292 13.9894Z",
    fill: "#FC9502"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02901 10.0938C7.53686 10.0938 7.53686 11.0342 8.18196 12.2898C8.61151 13.1259 7.96899 13.9918 7.02901 13.9918C6.08904 13.9918 5.60156 13.2298 5.60156 12.2898C5.60156 11.3499 6.52117 10.0938 7.02901 10.0938Z",
    fill: "#FCE202"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8106_43348",
    x1: 6.98103,
    y1: 14.0003,
    x2: 6.98103,
    y2: 0.0105715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b1bfe38ea1dfd20520f455e29a200085.svg";
export { ForwardRef as ReactComponent };